import { logGreyError, logUsage } from 'owa-analytics';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { getPlacesSettingsCache, type PlacesSettingsCacheEntry } from './database';

import type { MailboxInfo } from 'owa-client-types';

export function getOfflinePlacesSettings(
    mailboxInfo: MailboxInfo
): PlacesSettingsCacheEntry | undefined {
    try {
        const placesSettingsCache = getPlacesSettingsCache();

        const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);

        const result = placesSettingsCache?.[accountKey];

        if (result) {
            logUsage('GetOfflinePlacesSettingsSuccess', mailboxInfo, {
                PlacesWebAppEnabled: result.placesSettings.placesWebAppEnabled,
                PlacesPremiumEnabled: result.placesSettings.placesPremiumEnabled,
                PlacesCopilotEnabled: result.placesSettings.placesCopilotEnabled,
                PlacesFinderEnabled: result.placesSettings.placesFinderEnabled,
            });
        }

        return result;
    } catch (err) {
        logGreyError('GetOfflinePlacesSettingsError', mailboxInfo, err as Error);
        return undefined;
    }
}
